import type * as Types from 'app/types/graphql';

import {
  CampaignSelectFragmentDoc,
  CampaignVersionSelectFragmentDoc,
} from '../fragments/campaign.generated';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type CampaignUpdateBulkMutationVariables = Types.Exact<{
  input: Array<Types.BulkUpdateCampaignInput>;
}>;

export type CampaignUpdateBulkMutationResponse = {
  campaignBulkUpdate?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.Campaign,
          | 'id'
          | 'name'
          | 'type'
          | 'status'
          | 'priority'
          | 'storeDomain'
          | 'targetDevices'
          | 'targetChannels'
          | 'targetCountries'
          | 'targetVisitorTypes'
          | 'conditions'
          | 'createdAt'
          | 'updatedAt'
          | 'startedAt'
          | 'deletedAt'
          | 'completedAt'
        > & {
          group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
          versions?: Types.Maybe<
            Array<
              Types.Maybe<
                Pick<
                  Types.SplitTestingCampaignVersion,
                  'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
                >
              >
            >
          >;
        }
      >
    >
  >;
};

export const CampaignUpdateBulkDocument = `
    mutation CampaignUpdateBulk($input: [BulkUpdateCampaignInput!]!) {
  campaignBulkUpdate(input: $input) {
    ...CampaignSelect
  }
}
    ${CampaignSelectFragmentDoc}
${CampaignVersionSelectFragmentDoc}`;

export const useCampaignUpdateBulkMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CampaignUpdateBulkMutationResponse,
    TError,
    CampaignUpdateBulkMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CampaignUpdateBulkMutationResponse,
    TError,
    CampaignUpdateBulkMutationVariables,
    TContext
  >(
    ['CampaignUpdateBulk'],
    (variables?: CampaignUpdateBulkMutationVariables) =>
      appFetcher<CampaignUpdateBulkMutationResponse, CampaignUpdateBulkMutationVariables>(
        CampaignUpdateBulkDocument,
        variables,
      )(),
    options,
  );
};

useCampaignUpdateBulkMutation.getKey = () => ['CampaignUpdateBulk'];
